import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from "recharts";
  import { useEffect, useState } from "react";
import { getApiClient } from '../../libs/axiosInstance';
  
  export default function AiSalesForecast() {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [commentary, setCommentary] = useState("");
    const axios = getApiClient();


    useEffect(() => {
      (async () => {
        try {
        
          const res = await axios.get("/api/stats/sales-forecast");
          if (!res.data?.ok) return;
  
          const { actualHistory, aiForecast } = res.data;
  
          const combined = [
            ...actualHistory.map((m) => ({
              date: m._id,          // "2025-09"
              actual: m.total,
            })),
            ...aiForecast.map((f) => ({
              date: f.period,       // "2025-12"
              projected: f.total,
            })),
          ];
  
          setData(combined);
          setCommentary(res.data.commentary || "");
          setIsLoading(false);
        } catch (err) {
          console.error(err);
        }
      })();
    }, []);
  
    return (<div className='py-3'>
      
      <h3>Sales Forecast (Next 3 Months)</h3>
      <div className="card">
        <div className="card-body" style={{ height: 260 }}>
          {
            isLoading ? <>Loading forecast.. Please wait!</> :
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="actual"
                  dot={false}
                  stroke="#0d6efd"
                  name="Actual"
                />
                <Line
                  type="monotone"
                  dataKey="projected"
                  dot={false}
                  stroke="#198754"
                  strokeDasharray="5 5"
                  name="AI-adjusted forecast"
                />
              </LineChart>
            </ResponsiveContainer>
          }
        </div>
        {commentary && (
          <div className="card-footer py-2" style={{ fontSize: "0.75rem", color: "#666" }}>
            {commentary}
          </div>
        )}
      </div>
      </div>
    );
  }
  